import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function Loading({ isLoading }) {
  return (
    <div className="overflow-visible">
      <Backdrop sx={{ zIndex: 1200, color: '#FFF' }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
